import { jwtDecode } from "jwt-decode";
import isAccess from "./checkAccess";
import { setToastMessage, setToastOpen } from "../Actions/CustomerManagementAction";

export const fallback = (value) => value || "N/A";

export const getCustomerAccess = (token) => {
  const decodedToken = jwtDecode(token);
  return isAccess(decodedToken.userRole, "Customer Management");
};

export const processCustomerRows = (dashboardData) =>
  Array.isArray(dashboardData)
    ? dashboardData.map((row) => ({
        id: row.customerId,
        customerName: [row.firstName, row.lastName].filter(Boolean).join(" ") || "N/A",
        customerId: fallback(row.customerId),
        emailaddress: fallback(row.email),
        phoneNumber: fallback(row.phoneNumber),
        alternateNumber: fallback(row.alternateNumber),
        billingAddress: fallback(row.address),
      }))
    : [];

export const triggerToast = (dispatch, message, open = true) => {
  dispatch(setToastMessage(message));
  dispatch(setToastOpen(open));
};


export const getCustomerColumns = (
  edit,
  canDelete,
  handleEdit,
  setOpenDeleteModal,
  setDeviceIdToDelete,
  EditIcon,
  DeleteIcon,
  AccessibleTooltip
) => [
  {
    field: "customerName",
    headerName: "Customer Name",
    flex: 2,
    sortable: true,
  },
  {
    field: "customerId",
    headerName: "Customer ID",
    flex: 1,
    sortable: true,
  },
  {
    field: "emailaddress",
    headerName: "Email Address",
    flex: 2,
    sortable: true,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
    sortable: true,
  },
  {
    field: "alternateNumber",
    headerName: "Alternate Phone Number",
    flex: 1,
    sortable: true,
  },
  {
    field: "billingAddress",
    headerName: "Billing Address",
    flex: 1,
    sortable: true,
  },
  ...(edit || canDelete
    ? [
        {
          field: "Actions",
          headerName: "Actions",
          flex: 1,
          align: "right",
          headerAlign: "right",
          sortable: false,
          disableColumnMenu: true,
          renderCell: (row) => (
            <div style={{ display: "flex", gap: "10px" }} role="list">
              {edit && (
                <div role="listitem">
                  <AccessibleTooltip title="Edit">
                    <button
                      id={`edit-${row.row.id}`}
                      onClick={() => handleEdit(row, `edit-${row.row.id}`)}
                      className="icon-btn edit-icon-btn"
                      aria-label="Edit"
                    >
                      <img src={EditIcon} alt="" aria-hidden="true" className="editIcon" />
                    </button>
                  </AccessibleTooltip>
                </div>
              )}
              {canDelete && (
                <div role="listitem">
                  <AccessibleTooltip title="Delete">
                    <button
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setDeviceIdToDelete(row.row.id);
                      }}
                      className="icon-btn delete-icon-btn"
                      aria-label="Delete"
                    >
                      <img src={DeleteIcon} alt="" aria-hidden="true" className="deleteIcon" />
                    </button>
                  </AccessibleTooltip>
                </div>
              )}
            </div>
          ),
        },
      ]
    : []),
];
